import React from "react";
import logoWhite from "../assets/images/logoWhite.png";
import arrowUp from "../assets/images/arrowUp.svg";
import { Link } from "react-router-dom";

export const Footer = () => {
  function scrollToTop() {
    window.scrollTo(0, 0);
  }
  return (
    <div className="footer">
      <div className="fMain container">
        {/* <div className="contactRow row">
          <div className="col-md-6">
            <div className="contactM">
              <div className="cHead">Contact us Now</div>
              <div className="tagline">
                Want to grow your brand, launch a course, or work with top
                sponsors? Fill out the form below and we’ll be in touch shortly.
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="formMain">
              <div className="formTitle">
                Please fill out the form and our team will get back to you
                Shortly.
              </div>
              <div className="form-group">
                <label>Name</label>
                <input type="text" className="input" />
              </div>
              <div className="form-group">
                <label>Preferred Contact Method</label>
                <div className="radioM">
                  <div>
                    <input
                      type="radio"
                      name="preferedContact"
                      id=""
                      className="me-2"
                    />
                    Phone
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="preferedContact"
                      id=""
                      className="me-2"
                    />
                    Email
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label>Email</label>
                <input type="text" className="input" />
              </div>
              <div className="form-group">
                <label>Optional Message</label>
                <textarea name="" id="" rows={5} className="input"></textarea>
              </div>
              <button className="themeBtn w-100">Submit</button>
            </div>
          </div>
        </div> */}
        <div className="footRow2 pt-4">
          <div className="fLogo">
            <img src={logoWhite} alt="" />
            {/* LOGO */}
          </div>
          <div className="linkM">
            <Link className="text-secondry mb-2" to="/">
              Home
            </Link>
            <a className="text-secondry mb-2" href="#services">
              Solutions
            </a>
            {/* <Link className="text-secondry mb-2" to="/resource"><i className="bi bi-arrow-right text-primary me-2" />Resource</Link> */}
            <a className="text-secondry mb-2" href="#about">
              Why us
            </a>
            <Link className="text-secondry mb-2" to="/contact">
              Contact
            </Link>
          </div>

          <div className="socialM ">
            <a className="btn  rounded-circle me-2" href="#">
              <i className="fab fa-twitter" />
            </a>
            <a className="btn rounded-circle me-2" href="#">
              <i className="fab fa-facebook-f" />
            </a>
            <a className="btn rounded-circle me-2" href="#">
              <i className="fab fa-linkedin-in" />
            </a>
            <a className="btn rounded-circle" href="#">
              <i className="fab fa-instagram" />
            </a>
          </div>
        </div>
      </div>
      <div
        className="container py-4 py-lg-0 "
        style={{ background: "#111111" }}
      >
        <div className="py-lg-4 text-center rightReserveRow">
          <p className="text-secondary mb-0">
            © Copyright 2025, All Rights Reserved by Capital Media
          </p>
          {/* <p className="text-secondary mb-0">Powered by <a className="text-light fw-bold" href="https://theextremesolutions.com/" target="_blank">The Extreme Solutions</a></p> */}
        </div>
      </div>
    </div>
  );
};
